import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Typeahead } from "@merge-api/merge-javascript-shared";
import { LinkedAccountsFilters } from "../../hooks/useLinkedAccountsFilters";
import { APICategory } from "../../../../../../models/Entities";
import { categoryDisplayName } from "../../../../../../models/Helpers";
import { useFilterOptions } from "./hooks/useFilterOptions";
import LinkedAccountsFilterPopover from "./components/LinkedAccountsFilterPopover";
import LinkedAccountsSearchField from "./components/LinkedAccountsSearchField";

interface Props {
  filters: LinkedAccountsFilters;
  onFiltersChange: (filters: LinkedAccountsFilters) => void;
  disabled?: boolean;
}

const LinkedAccountsFilterBar = ({ filters, onFiltersChange, disabled }: Props) => {
  const { integrationNames, isLoading } = useFilterOptions();
  const history = useHistory();
  const [navigationKey, setNavigationKey] = useState(0);

  useEffect(
    () =>
      history.listen((_, action) => {
        if (action !== "REPLACE") setNavigationKey((key) => key + 1);
      }),
    [history],
  );

  return (
    <div className="flex flex-col lg:flex-row lg:items-start gap-3 mb-6">
      <div className="lg:w-80">
        <LinkedAccountsSearchField
          value={filters.search}
          disabled={disabled}
          onChange={(search) => onFiltersChange({ ...filters, search })}
        />
      </div>
      <div className="lg:w-56">
        <Typeahead
          key={navigationKey}
          placeholder="Integration"
          options={integrationNames}
          value={filters.integrationName}
          loading={isLoading}
          disabled={disabled}
          onChange={(_, integrationName) =>
            onFiltersChange({ ...filters, integrationName: integrationName as string | null })
          }
        />
      </div>
      <div className="lg:w-56">
        <Typeahead
          key={navigationKey}
          placeholder="Category"
          options={Object.values(APICategory)}
          value={filters.category}
          disabled={disabled}
          getOptionLabel={(category) => categoryDisplayName(category as APICategory)}
          onChange={(_, category) =>
            onFiltersChange({ ...filters, category: category as string | null })
          }
        />
      </div>
      <LinkedAccountsFilterPopover
        filters={filters}
        onFiltersChange={onFiltersChange}
        disabled={disabled}
      />
    </div>
  );
};

export default LinkedAccountsFilterBar;
